import React from "react";
import { useState, useEffect } from "react";
import { TextField, Typography, Button } from '@mui/material';
import Axios from "axios";
import { apiPath } from "../services/const";

function PasswordRecoveryRequest({classes, state, sendDataToParent,}){
    const [input, setInput] = useState({
        login:""
    });

    const [timeRemaining, setTimeRemaining] = useState(45)
    const [timerStarted, setTimerStarted] = useState(false)
    useEffect(()=>{
        if (timerStarted){
            const timer = setInterval(()=>{
                setTimeRemaining((time) => {
                    if (time <= 0){
                        clearInterval(timer);
                        setTimerStarted(false)
                        sendDataToParent({msg:""})
                        return 45
                    } else {return time - 1}
                });
            }, 1000);}},[timerStarted, sendDataToParent])

    const updateLogin = (event) =>{
        const newValue = event.target.value
            if (newValue.length <=5){
                setInput({login:newValue})
            }
    }

    const sendPasswordChangeRequest = (userdata) => {
        Axios.post(`${apiPath}/users/password-reset/request/${userdata}`,{
            
        },{params:{
                callbackUrl:window.location.href
            },
            headers:{
                accept: 'application/json'
            }
        })
        .then(response => {
            if (response.data && response.data.detail){
                sendDataToParent({msg: response.data.detail, emailOk: true})
                setTimerStarted(true)
            }})
        .catch(err => {
            const status = err.response?.status
            switch (true) {
                case status < 500:
                    sendDataToParent({msg: err.response.data.detail, emailOk: false})
                    break
                default:
                    sendDataToParent({msg: "Houve um problema com o Servidor. Tente Novamente mais tarde", emailOk: false })
                    break
            }
        })
    }

    const handleRequestPasswordClick = () => {
        if (input.login.length >= 5){
                sendPasswordChangeRequest(input.login)
        } else {
            sendDataToParent({msg : "O Login deve iniciar com C ou H seguido de 4 caractes numéricos", emailOk:false})
        }
    }

    return(
        <div>
            <Typography variant="h5" className={classes.recoveryMainText}>Recuperar Senha</Typography>
            <Typography className={classes.text} variant="body2"> Informe seu login de acesso. Enviaremos um link de redefinição para os e-mails cadastrados nessa conta.</Typography>
            <div className={classes.inputBox}>
                <TextField  variant="outlined" disabled={timerStarted} required fullWidth id="login" label="Login do Usuário" name="login" autoFocus onChange={(e)=>updateLogin(e)} value={input.login}/>
                <Button fullWidth className={classes.button} variant="contained" disabled={timerStarted} color="primary" onClick={handleRequestPasswordClick}>{timerStarted? `Reenviar em ${timeRemaining}s`: 'Enviar'}</Button>
            </div>
        </div>

    )
}

export default PasswordRecoveryRequest